<template>
	<div
		:class="['dc-post-grid-input-wrapper', { focused: focused }]"
		v-on:click="focusSearch()"
	>
		<input
			ref="searchInput"
			id="dc-post-grid-search-input"
			name="dc-post-grid-search"
			type="search"
			v-model="value"
			:placeholder="searchFormPlaceholder"
			:class="['dc-post-grid-search-input']"
			@focus="focused = true"
			@blur="focused = false"
		/>
	</div>
</template>

<script>
import { ref } from 'vue'
export default {
	setup() {
		const searchInput = ref()

		return {
			searchInput,
		}
	},
	props: {
		model: {
			type: String,
			required: false,
		},
		searchFormPlaceholder: {
			type: String,
			default: '',
			required: true,
		},
	},
	data() {
		return {
			focused: false,
			value: null,
		};
	},
	methods: {
		focusSearch() {
			this.searchInput.focus();
		},
	},
	mounted() {
		this.value = this.model
	},
	watch: {
		value(newVal) {
			this.$emit('updateSearchTerm', newVal);
		}
	},
};
</script>
